import { acqDiscoverSku } from "@/entities/pricing/model/priceBook";
import { usePriceBook } from "@/entities/pricing/model/usePriceBook";

import type { AcqCatalogItem } from "../api/acqService";

/**
 * 跑一次「发现」要扣多少积分。
 *
 * ★ 两个出处都是**服务端**的,前端一个数都不编:
 *   ① 目录行自带的 `priceCredits`(服务端从 PricingService 现读)—— 优先,它是此刻的实价;
 *   ② 平台价目表 `acq.discover.{type}`(V42 落地后才有)—— 兜底。
 * ★ 两个都取不到返回 `null`,调用方一律写「按次计费」。
 *   兜一个数(哪怕是上一版的数)等于把一个可能过期的价钱说成真的,而用户会照着它做决定。
 * ★ `0` **不是** null:0 要写成「免费」。屏幕上「0 积分」看着像坏了,「免费」才是白送
 *   (与 `PriceBook.isFree` 同一条理由)。
 */
export function useDiscoverPrice(
  item: Pick<AcqCatalogItem, "type" | "priceCredits">
): number | null {
  const { book } = usePriceBook();
  if (item.priceCredits != null) return item.priceCredits;
  return book.unit(acqDiscoverSku(item.type)) ?? book.unit(acqDiscoverSku(item.type), "default");
}

/** 价签文案。**三态**:没价 / 免费 / N 积分 —— 三种说法都不一样,不许合并。 */
export function discoverPriceText(credits: number | null): string {
  if (credits == null) return "按次计费";
  if (credits === 0) return "免费";
  return `${credits} 积分`;
}
